import { Component, Input, OnInit, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { TranslateService } from "@ngx-translate/core";
import { CodeInputComponent } from "angular-code-input";
import { UserHttpClientService } from "src/app/data/user-http-client.service";
import { PersonalRegisterRequest } from "src/app/models/Register/register";
import { Client } from "src/app/services/API/client";
import { LoginHub } from "src/app/services/Hub/hub.login.service";
import { LocalStorage } from "src/app/services/local-storage";
import { SessionService } from "src/app/services/session.service";
import { ModalAuthService } from "src/app/services/ux/modal-auth.service";
import { toastrService } from "src/app/services/ux/toastr.service";
import { environment } from "src/environments/environment";

interface ICountry {
  name: {
    [key: string]: string
  }
  code: string
  dial_code: string
  flag: string
}

const DEFAULT_COUNTRY: ICountry = {
  name: {
    en: "Albania"
  },
  dial_code: "+355",
    code: "AL",
    flag: "🇦🇱"
}
@Component({
  selector: "business-register",
  templateUrl: "./business-register.component.html",
  styleUrls: ["./business-register.component.css"]
})
export class BusinessRegisterComponent {

  loading: boolean = false

  email: string = ''
  companyName: string = ''
  administratorFirstname: string = ''
  administratorLastname: string = ''
  nipt: string = ''
  celNr: string = ''
  password: string = ''
  confirmPassword: string = ''
  termsApproved: boolean = false
  contractApproved: boolean = false
  // passwordSecureTextEntry: true
  // repeatPasswordSecureTextEntry: true

  showConfirmModal: boolean = false
  confirmOtpModal: boolean = false

  operationId: string = null

  isOpenCountryModal: boolean = false
  selectedCountry: ICountry = DEFAULT_COUNTRY

  @ViewChild('codeInput') codeInput !: CodeInputComponent;

  constructor(
    private modalService: ModalAuthService,
    public toastr: toastrService,
    private session: SessionService,
    private api: Client,
    private _hub: LoginHub,
    private router: Router,
    private translateService: TranslateService,
    public localStorage: LocalStorage,
    private userService: UserHttpClientService
  ) {
    this.prepareHub()

    // * Will allways emit true values
    this._hub.retryLoginEventEmitter.subscribe((shouldRetry: boolean) => {

    });

    // * Will allways emit true values
    this._hub.loginRejectEventEmitter.subscribe((event: boolean) => {

    });

  }

  private prepareHub() {
    this._hub.buildConnection();
    this._hub.startConnection();
  }

  openConfirmModal() {
    this.showConfirmModal = true
  }

  closeConfirmModal() {
    this.showConfirmModal = false
  }

  openConfirmOTPModal() {
    this.confirmOtpModal = true
  }

  closeConfirmOTPModal() {
    this.confirmOtpModal = false
  }

  getSuccessOTPMessage(type: number) {
    let typeString = ""
    if (type === 1) typeString = this.translateService.instant("Email");
    if (type === 2) typeString = "SMS"

    return this.translateService.instant("ModalComponent.Auth.PleaseCheckToGetSecurityCode", { method: typeString })
  }

  async send(sendType: number) {
    if (this.loading) return
    const passed = this.validateUserInput()
    if (!passed) return
    this.loading = true

    const { email, companyName, administratorFirstname, administratorLastname, nipt, celNr, password, confirmPassword } = this
    const responseObj = {
      email: email,
      companyName: companyName,
      nipt: nipt.toUpperCase(),
      administratorFirstname: administratorFirstname,
      administratorLastname: administratorLastname,
      celNr: environment.useNewPhoneNumberFormat ? `${this.selectedCountry.dial_code}${celNr}` : celNr,
      password,
      confirmPassword
    }

    try {
      await this.RegisterBiznes(responseObj)

      const data: any = await this.api.postLogin("login", {
        grant_type: "password",
        client_id: "EternaWebPosta",
        Username: email,
        Password: this.password,
        ConnectionId: this._hub.hubConnection.connectionId,
        sendType
      })
      const { id, sent, type } = data
      if (!sent) {
        this.toastr.error(this.translateService.instant("ModalComponent.Auth.SomethingWrong"))
        return
      }

      this.toastr.success(this.getSuccessOTPMessage(type))
      this.operationId = id
      this.closeConfirmModal()
      this.openConfirmOTPModal()
    } catch (err) {
      this.toastr.error(err.response && err.response.data || err.message)
    }

    this.loading = false
  }

  async verifyOTP(otp: string) {
    if (this.loading) return

    this.loading = true
    try {
      const data: any = await this.api
        .post("api/otp/verifyCode", {
          operationId: this.operationId,
          otp
        })
      this.localStorage.set(
        "auth",
        JSON.stringify({
          access_token: data.mobileToken.token,
          expires_in: data.mobileToken.expiresIn
        })
      );
      this.loading = false
      this.confirmOtpModal = false
      this.operationId = ""
      this.modalService.close();
      // this.loginModal = true
      this.userService.getUserDetails().subscribe(data => { })
      this.router.navigateByUrl("/")
    } catch (err) {
      this.toastr.error(this.translateService.instant("ModalComponent.Auth.WrongSecurityCode"));
    }
    this.codeInput.reset()
    this.loading = false
  }

  setTermsApproved() {
    this.termsApproved = !this.termsApproved
  }

  setContractApproved() {
    this.contractApproved = !this.contractApproved
  }

  async checkLogin() {
    if (!!this.session.isLoggedIn()) this.router.navigateByUrl("/")
  }

  async SimpleRegister(userObject: PersonalRegisterRequest) {
    const registerUrl = 'api/auth/v2/register';
    try {
      const data = await this.api.post(registerUrl, userObject)
    } catch (err) {
      this.toastr.error(err.response && err.response.data || err.message)
    }
  }

  async RegisterBiznes(userObject: any) {
    const registerUrl = 'api/auth/company/register';

    try {
      const data = await this.api.post(registerUrl, userObject)
    } catch (err) {
      this.toastr.error(err.response && err.response.data || err.message)
    }
  }

  validateUserInput(noAlert: boolean = false) {
    try {
      const {
        email, companyName, administratorFirstname, administratorLastname, nipt, celNr, password, confirmPassword, termsApproved, contractApproved
      } = this;

      const emailRegex = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
      const passRegex = /^(?:(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).*)$/;
      const numRegex = /^(((06)\d{8})){1}$/;
      const niptRegex = /^[a-zA-Z][0-9]{8}[a-zA-Z]$/;

      if (!email || !emailRegex.test(email)) throw new Error(this.translateService.instant("RegisterComponent.EmailAddressIsIncorrect"))
      if (!companyName || companyName.length < 3) throw new Error(this.translateService.instant("RegisterComponent.TheCompanyNameMustBeAtLeast3CharactersLong"))
      if (!administratorFirstname || administratorFirstname.length < 3) throw new Error(this.translateService.instant("RegisterComponent.TheNameOfTheCompanyAdministratorMustBeAtLeast3Characters"))
      if (!administratorLastname || administratorLastname.length < 3) throw new Error(this.translateService.instant("RegisterComponent.TheAdministratorSurnameOfTheCompanyMustBeAtLeas3Characters"))
      if (
        !environment.useNewPhoneNumberFormat &&
        (!celNr || !numRegex.test(celNr))
      )
        throw new Error(
          this.translateService.instant(
            "RegisterComponent.MobileNumberMustBeInTheFormat"
          )
        );
        if (
          environment.useNewPhoneNumberFormat && !celNr)
          throw new Error(
            this.translateService.instant(
              "RegisterComponent.PleaseEnterPhoneNumber"
            )
          );
      if (!nipt || !niptRegex.test(nipt)) throw new Error(this.translateService.instant("RegisterComponent.NIPTIsNotInTheCorrectFormat"))

      if (!password || password.length < 6) throw new Error(this.translateService.instant("RegisterComponent.PasswordMustBeAtLeast6CharactersLong"))
      if (!confirmPassword) throw new Error(this.translateService.instant("RegisterComponent.PleaseConfirmThePassword"))
      if (!passRegex.test(password) || !passRegex.test(confirmPassword)) throw new Error(this.translateService.instant("RegisterComponent.ThePasswordMustContainAtLeastOneCapitalLetterAndOneNumber"))
      if (password !== confirmPassword) throw new Error(this.translateService.instant("RegisterComponent.PasswordDoesNotMatch"))

      if (!termsApproved) throw new Error(this.translateService.instant("RegisterComponent.YouMustAcceptTheTermsOfUseAndPrivacyPolicy"))
      if (!contractApproved) throw new Error(this.translateService.instant("RegisterComponent.YouMustAcceptTheEPostaServiceContract"))
      return true;

    } catch (err) {
      !noAlert && this.toastr.error(err.message)
      return false
    }
  }

  // togglePassword = () => {
  //   this.isShowPassword = !this.isShowPassword
  // };

  // toggleRepeatPassword = () => {
  //   this.isShowConfirmPassword = !this.isShowConfirmPassword
  // };

  setOtpModalRef = (element: any) => {
    // this.otpDestinationModalRef = element;
  };
  
  openCountryModal = () => {
    this.isOpenCountryModal = true
  }

  closeCountryModal = () => {
    this.isOpenCountryModal = false
  }

  onSelectCountry = (country: ICountry) => {
    this.selectedCountry = country
    this.isOpenCountryModal = false
  }

  showCountryPicker = () => environment.useNewPhoneNumberFormat
}
